"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Form = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _Snackbar = _interopRequireWildcard(require("../Snackbar"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _formSubmissionReducer = _interopRequireWildcard(require("./reducers/formSubmissionReducer"));
var _useScrollOnError = _interopRequireDefault(require("./hooks/useScrollOnError"));
var _ModalDialog = _interopRequireDefault(require("../Dialog/ModalDialog"));
var _SRErrors = _interopRequireDefault(require("./a11y/SRErrors"));
var _ErrorBoundary = require("../ErrorTracking/ErrorBoundary");
var _excluded = ["children", "handleSubmit", "onSubmitSuccess", "onSubmitError", "submitSuccessTitle", "submitErrorTitle", "submitErrorBody", "multipleFieldsValidator", "isDetailedError", "initialValues", "id", "validationMode"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Form = exports.Form = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    handleSubmit = _ref.handleSubmit,
    onSubmitSuccess = _ref.onSubmitSuccess,
    onSubmitError = _ref.onSubmitError,
    submitSuccessTitle = _ref.submitSuccessTitle,
    submitErrorTitle = _ref.submitErrorTitle,
    submitErrorBody = _ref.submitErrorBody,
    multipleFieldsValidator = _ref.multipleFieldsValidator,
    isDetailedError = _ref.isDetailedError,
    initialValues = _ref.initialValues,
    id = _ref.id,
    validationMode = _ref.validationMode,
    props = _objectWithoutProperties(_ref, _excluded);
  var formRef = ref || (0, _react.useRef)(null);
  var methods = (0, _reactHookForm.useForm)({
    mode: validationMode,
    criteriaMode: 'all',
    shouldFocusError: false,
    defaultValues: initialValues
  });
  (0, _useScrollOnError["default"])({
    errors: methods.errors,
    ref: formRef
  });
  var _useReducer = (0, _react.useReducer)(_formSubmissionReducer["default"], {
      showSnackbar: false,
      detailedErrorOpen: false,
      isSuccess: true,
      feedbackMessage: ''
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var onRequestSuccess = function onRequestSuccess(response) {
    onSubmitSuccess(response);
    dispatch({
      type: _formSubmissionReducer.SubmissionStatus.SUCCESS,
      payload: submitSuccessTitle
    });
  };
  var onRequestError = function onRequestError(error) {
    onSubmitError(error);
    if (isDetailedError) {
      dispatch({
        type: _formSubmissionReducer.SubmissionStatus.DETAILED_ERROR
      });
    } else {
      dispatch({
        type: _formSubmissionReducer.SubmissionStatus.ERROR,
        payload: submitErrorTitle
      });
    }
  };
  var executeDependantFieldsCustomValidations = function executeDependantFieldsCustomValidations(formData) {
    var dependantFieldsWithError = multipleFieldsValidator(formData);
    dependantFieldsWithError.forEach(function (fieldName) {
      return methods.setError(fieldName, {
        type: 'manual',
        types: {
          manual: ''
        }
      });
    });
    return dependantFieldsWithError;
  };
  var executeSubmission = methods.handleSubmit(function (formData) {
    var dependantFieldsWithError = executeDependantFieldsCustomValidations(formData);
    if (!dependantFieldsWithError.length && handleSubmit) {
      return Promise.resolve(handleSubmit(formData)).then(onRequestSuccess)["catch"](onRequestError);
    }
    return null;
  });
  var showSnackbar = state.showSnackbar,
    feedbackMessage = state.feedbackMessage,
    isSuccess = state.isSuccess,
    detailedErrorOpen = state.detailedErrorOpen;
  var showSuccess = isSuccess && submitSuccessTitle;
  var showError = !isSuccess && submitErrorTitle;
  return /*#__PURE__*/_react["default"].createElement(_reactHookForm.FormProvider, _extends({}, methods, props), /*#__PURE__*/_react["default"].createElement("form", {
    ref: formRef,
    onSubmit: executeSubmission,
    id: id
  }, /*#__PURE__*/_react["default"].createElement(_SRErrors["default"], null), children), /*#__PURE__*/_react["default"].createElement(_ModalDialog["default"], {
    open: detailedErrorOpen,
    onClose: function onClose() {
      return dispatch({
        type: _formSubmissionReducer.SubmissionStatus.UNSUBMITTED
      });
    },
    title: submitErrorTitle
  }, submitErrorBody), (showSuccess || showError) && /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    open: showSnackbar,
    onClose: function onClose() {
      return dispatch({
        type: _formSubmissionReducer.SubmissionStatus.UNSUBMITTED
      });
    },
    onClick: executeSubmission,
    color: isSuccess ? _Snackbar.SnackbarColors.SUCCESS : _Snackbar.SnackbarColors.ERROR,
    message: /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, feedbackMessage)
  }));
});
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  handleSubmit: _propTypes["default"].func,
  onSubmitSuccess: _propTypes["default"].func,
  onSubmitError: _propTypes["default"].func,
  submitSuccessTitle: _propTypes["default"].string,
  submitErrorTitle: _propTypes["default"].string,
  submitErrorBody: _propTypes["default"].string,
  multipleFieldsValidator: _propTypes["default"].func,
  isDetailedError: _propTypes["default"].bool,
  initialValues: _propTypes["default"].object,
  id: _propTypes["default"].string,
  validationMode: _propTypes["default"].oneOf(['onBlur', 'onChange', 'onSubmit', 'all'])
} : {};
Form.defaultProps = {
  onSubmitError: function onSubmitError() {
    return null;
  },
  onSubmitSuccess: function onSubmitSuccess() {
    return null;
  },
  multipleFieldsValidator: function multipleFieldsValidator() {
    return [];
  },
  isDetailedError: false,
  submitErrorBody: '',
  initialValues: {},
  validationMode: 'onBlur'
};
var _default = exports["default"] = (0, _ErrorBoundary.withErrorBoundary)(Form);